
import { Button } from 'react-bootstrap';
import React from 'react';
import Youtube from '../components/Youtube';

const Homepage = () =>
(
    <div className='Homepage' align="center">
        <h1 className="text-light">Bootstrap Bill</h1>
        <Youtube embedId='c8qGuXCOV0Q' />
        <br />
        <Button href="/budget"><h1>Start Budgeting</h1></Button>
    </div>
)


export default Homepage;
